export default {
    setPosts(state, posts) {
        state.posts = posts;
    },
    setCategories(state, categories) {
        state.categories = categories;
    },
    setCurrentPost(state, post) {
        state.currentPost = post;
    },
    setCurrentCategory(state, cat) {
        state.currentCategory = state.currentCategory != cat ? cat : null;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/mutations.ts
// module id = null
// module chunks = 